
<div class="hardCopyActivityAuditSection">
    <app-hardcopyactivity-audit-life-cycle *ngIf="isHardCopyActivityAuditDetailsDataLoaded && !showLoader"
        [auditLifecycleInput]="hardCopyActivityLifeCycleDetails">
    </app-hardcopyactivity-audit-life-cycle>
    <p-fieldset legend="Audit Trail" *ngIf="isHardCopyActivityAuditDetailsDataLoaded && !showLoader">
        <div class="grid">
            <div class="col-6">
                <app-hardcopyactivity-audit-summary [auditSummaryDetails]="hardCopyActivityAuditSummaryDetails"
                    (attributeDetailsOfTransaction)="showAuditItemDetails($event)"></app-hardcopyactivity-audit-summary>
            </div>
            <div class="col-6 auditTrialDetailsSection">
                <app-audit-item-details
                    [auditTrialDetails]="auditAttributeDetailsOfTransaction"></app-audit-item-details>
            </div>
        </div>
    </p-fieldset>

</div>